// Local fallback partner logos (rehosted as bundled assets).
// Rendered with a CSS mask so the source colors are replaced with a
// semi-transparent white silhouette in the marquees.
import charite from "@/assets/partners/charite.svg";
import artemed from "@/assets/partners/artemed.png?format=webp&w=240&quality=78";
import heidelberg from "@/assets/partners/heidelberg.svg";
import helseNord from "@/assets/partners/helse-nord.svg";
import helseSorOst from "@/assets/partners/helse-sor-ost.svg";
import helseVest from "@/assets/partners/helse-vest.png?format=webp&w=240&quality=78";
import imperial from "@/assets/partners/imperial-college.png?format=webp&w=240&quality=78";
import karolinska from "@/assets/partners/karolinska.png?format=webp&w=240&quality=78";
import kingsCollegeHospital from "@/assets/partners/kings-college-hospital.svg";
import kingsCollegeLondon from "@/assets/partners/kings-college-london.svg";
import massGeneralBrigham from "@/assets/partners/mass-general-brigham.svg";
import meritus from "@/assets/partners/meritus-health.svg";
import nhsCambridge from "@/assets/partners/nhs-cambridge.svg";
import nhsGuysStThomas from "@/assets/partners/nhs-guys-st-thomas.svg";
import nhsLewishamGreenwich from "@/assets/partners/nhs-lewisham-greenwich.svg";
import radboudUmc from "@/assets/partners/radboud-umc.svg";
import tuDresden from "@/assets/partners/tu-dresden.svg";
import tuMunchen from "@/assets/partners/tu-munchen.svg";
import lmuKlinikum from "@/assets/partners/lmu-klinikum.png?format=webp&w=240&quality=78";
import ucl from "@/assets/partners/ucl.svg";
import universitatBasel from "@/assets/partners/universitat-basel.png?format=webp&w=240&quality=78";
import universitatRegensburg from "@/assets/partners/universitat-regensburg.svg";
import universitatUlm from "@/assets/partners/universitat-ulm.svg";
import universitatsspitalZurich from "@/assets/partners/universitatsspital-zurich.svg";
import vivantes from "@/assets/partners/vivantes.svg";
import reginaMaria from "@/assets/partners/regina-maria.svg";
import clinicaAlemana from "@/assets/partners/clinica-alemana.png?format=webp&w=240&quality=78";
import osloUniversitetssykehus from "@/assets/partners/oslo-universitetssykehus.svg";
import spaarneGasthuis from "@/assets/partners/spaarne-gasthuis.svg";
import noordwestZiekenhuisgroep from "@/assets/partners/noordwest-ziekenhuisgroep.png?format=webp&w=240&quality=78";


export interface LocalPartnerLogo {
  name: string;
  src: string;
  scale?: number;
}

export const localPartnerLogos: LocalPartnerLogo[] = [
  { name: "TU München", src: tuMunchen },
  { name: "LMU University Hospital", src: lmuKlinikum },
  { name: "TU Dresden", src: tuDresden, scale: 1.15 },
  { name: "Universität Regensburg", src: universitatRegensburg, scale: 1.5 },
  { name: "Universität Ulm", src: universitatUlm },
  { name: "King's College London", src: kingsCollegeLondon },
  { name: "King's College Hospital", src: kingsCollegeHospital },
  { name: "UCL", src: ucl, scale: 0.7 },
  { name: "Imperial College", src: imperial },
  { name: "NHS Cambridge", src: nhsCambridge },
  { name: "NHS Guy's & St Thomas'", src: nhsGuysStThomas },
  { name: "NHS Lewisham & Greenwich", src: nhsLewishamGreenwich },
  { name: "Artemed Hospitals", src: artemed },
  { name: "Radboud UMC", src: radboudUmc },
  { name: "Spaarne Gasthuis", src: spaarneGasthuis },
  { name: "Noordwest Ziekenhuisgroep", src: noordwestZiekenhuisgroep },
  { name: "Universität Basel", src: universitatBasel },
  { name: "Universitätsspital Zürich", src: universitatsspitalZurich },
  { name: "Helse Sør-Øst", src: helseSorOst },
  { name: "Meritus Health", src: meritus },
  { name: "Oslo Universitetssykehus", src: osloUniversitetssykehus, scale: 1.5 },
  { name: "Vivantes", src: vivantes },
  { name: "Regina Maria", src: reginaMaria },
  { name: "Clínica Alemana", src: clinicaAlemana },
];
